import { createContext, useContext, type ReactNode } from 'react';
import type { PreviewMode } from '../types';

/**
 * Minimum settings the preview pane needs from the host application. The
 * desktop client maps these to its main settings store; the Mini App will
 * supply equivalent values from its own state.
 */
export interface PreviewSettings {
  previewMode: PreviewMode;
  setPreviewMode: (mode: PreviewMode) => void;
  videoAutoplay: boolean;
}

const PreviewSettingsContext = createContext<PreviewSettings | null>(null);

interface PreviewSettingsProviderProps {
  value: PreviewSettings;
  children: ReactNode;
}

export function PreviewSettingsProvider({ value, children }: PreviewSettingsProviderProps) {
  return (
    <PreviewSettingsContext.Provider value={value}>
      {children}
    </PreviewSettingsContext.Provider>
  );
}

export function usePreviewSettings(): PreviewSettings {
  const ctx = useContext(PreviewSettingsContext);
  if (!ctx) {
    throw new Error('usePreviewSettings must be used inside <PreviewSettingsProvider>');
  }
  return ctx;
}
